var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "40px",
    height: "40px",
    clipRule: "evenodd",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#060000",
    d: "M43.462,52H20.538c-2.28,0-4.424-0.888-6.037-2.5C12.889,47.887,12,45.743,12,43.461V20.539 c0-2.281,0.889-4.426,2.501-6.038c1.613-1.612,3.757-2.5,6.037-2.5h22.924c2.28,0,4.424,0.888,6.037,2.5 C51.111,16.113,52,18.257,52,20.539v22.923c0,2.281-0.889,4.426-2.501,6.038C47.886,51.112,45.742,52,43.462,52z M20.538,16 c-1.212,0-2.352,0.472-3.209,1.33C16.472,18.186,16,19.326,16,20.539v22.923c0,1.213,0.472,2.353,1.329,3.209 c0.857,0.857,1.997,1.33,3.209,1.33h22.924c1.212,0,2.352-0.472,3.209-1.33C47.528,45.814,48,44.674,48,43.461V20.539 c0-1.213-0.472-2.353-1.329-3.209C45.813,16.472,44.674,16,43.462,16H20.538z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M41.538,31.934C42.508,32.927,43,34.252,43,35.875 c0,1.156-0.24,2.196-0.713,3.09c-0.455,0.87-1.091,1.612-1.887,2.202c-0.894,0.661-1.89,1.14-2.963,1.424 C36.385,42.867,35.118,43,33.562,43H25c-0.553,0-1-0.448-1-1V22c0-0.266,0.105-0.521,0.294-0.708C24.481,21.105,24.735,21,25,21 c0.001,0,0.003,0,0.004,0l7.158,0.03c7.849,0,9.021,3.538,9.021,5.646c0,1.173-0.318,2.238-0.947,3.167 c-0.177,0.263-0.398,0.51-0.665,0.744C40.338,30.925,40.993,31.375,41.538,31.934z M30.526,26v3.636h2.684 c0.989,0,1.789-0.814,1.789-1.818C35,26.814,34.199,26,33.211,26H30.526z M33.951,38.364c1.059,0,1.917-1.017,1.917-2.273 c0-1.255-0.858-2.273-1.917-2.273H30.5v4.542L33.951,38.364z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.f5d6b901bbef6d9c67b25f7bebaf87e9.svg";
export { ForwardRef as ReactComponent };